import { render, staticRenderFns } from "./CustomFieldsTable.vue?vue&type=template&id=636fe7c0&scoped=true&"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsTable.vue?vue&type=style&index=0&id=636fe7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fe7c0",
  null
  
)

export default component.exports